import { StandardEvents } from '@shopify/events';

class EdVariantSku extends HTMLElement {
  #request = 0;

  connectedCallback() {
    document.addEventListener(StandardEvents.productSelect, this.#update);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.productSelect, this.#update);
  }

  #update = (event) => {
    const productId = String(event.product?.id || event.target?.closest?.('variant-picker')?.dataset.productId || '').split('/').pop();
    if (productId !== this.dataset.productId || !event.promise) return;
    const request = ++this.#request;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || request !== this.#request || !detail) return;
      if (String(detail.productId).split('/').pop() !== this.dataset.productId) return;
      const sku = detail.resource?.sku || '';
      this.textContent = sku;
      const row = this.closest('[data-ed-sku-row]');
      if (row) row.hidden = !sku;
    }).catch(() => {});
  };
}

if (!customElements.get('ed-variant-sku')) customElements.define('ed-variant-sku', EdVariantSku);
